import { mobileFormatStrategy } from './mobile-format-strategy';
import { mobileLengthStrategy } from './mobile-length-strategy';

export const mobileStrategy = (value: string) => {
  return mobileLengthStrategy(value) && mobileFormatStrategy(value);
};
